var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"image-preview-wrap"},[_c('img',{staticClass:"image-preview-content",attrs:{"src":_vm.imageUrl,"fit":"cover"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }